import { Navigate } from "react-router-dom";
import { PageLayout } from "@/components/layout/PageLayout";
import { PageTitle } from "@/components/ui/page-title";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { useAuth } from "@/hooks/useAuth";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PAGE_INFO_GUIDE_ROUTE } from "@/components/page-info/pageInfoRegistry";

/**
 * The public help page. Signed-in readers have the full guide under
 * Settings → Help (every page's tasks, search, the same FAQs), so they are
 * sent there; signed-out visitors get the introduction and FAQs.
 */
export default function Help() {
  const { t } = useLanguage();
  const { userId, isLoading } = useAuth();

  if (!isLoading && userId) return <Navigate to={PAGE_INFO_GUIDE_ROUTE} replace />;

  return (
    <PageLayout>
      <div className="mx-auto max-w-3xl">
        <PageTitle className="mb-6">{t.common.help}</PageTitle>

        <section className="mb-10">
          <h2 className="mb-4 text-lg font-semibold">{t.common.info}</h2>
          <p className="mb-4">{t.help.introParagraph}</p>
        </section>

        <section className="mb-10">
          <h2 className="mb-4 text-lg font-semibold">{t.help.faqsTitle}</h2>
          <Accordion type="single" collapsible className="w-full">
            {t.help.faqs.map((faq) => (
              <AccordionItem value={faq.question} key={faq.question}>
                <AccordionTrigger>{faq.question}</AccordionTrigger>
                <AccordionContent>{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </section>
      </div>
    </PageLayout>
  );
}
